<template>
  <div class="content">
    <div class="condition" style="margin-bottom: 20px">
      <div>
        <el-row>
          <el-col :span="4">
            <div class="type">发布日期：</div>
          </el-col>
          <el-col :span="20">
            <div class="but">
              <span
                @click="changeType('0')"
                class="typeBut all"
                :class="{ active: active == '0' }"
                >所有</span
              >
              <span
                @click="changeType('1')"
                class="typeBut"
                :class="{ active: active == '1' }"
                >24小时内</span
              >
              <span
                @click="changeType('2')"
                class="typeBut"
                :class="{ active: active == '2' }"
                >近三天</span
              >
              <span
                @click="changeType('3')"
                class="typeBut"
                :class="{ active: active == '3' }"
                >近一周</span
              >
              <span
                @click="changeType('4')"
                class="typeBut"
                :class="{ active: active == '4' }"
                >近一月</span
              >
              <span
                @click="changeType('5')"
                class="typeBut"
                :class="{ active: active == '5' }"
                >一个月前</span
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <el-divider></el-divider>
      <div>
        <el-row>
          <el-col :span="4">
            <div class="type">月薪范围：</div>
          </el-col>
          <el-col :span="20">
            <div class="but">
              <span
                @click="changeType2({ id: '0' })"
                class="typeBut all"
                :class="{ active: active2 == '0' }"
                >所有</span
              >
              <span
                @click="changeType2(item)"
                v-for="(item, index) in metaQyList"
                :key="index"
                class="typeBut"
                :class="{ active: active2 == item.id }"
                >{{ item.nodeName }}</span
              >
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div>
      <div style="padding: 10px 0; text-align: right">
        <el-input
          v-model="input"
          placeholder="请输入名称搜索"
          style="width: 200px"
          suffix-icon="el-icon-search"
          @change="change"
          size="small"
        ></el-input>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%; cursor: pointer"
        @row-click="rowClick"
      >
        <el-table-column
          prop="jobName"
          label="职位名"
          width="300"
        ></el-table-column>
        <el-table-column
          prop="enterpriseName"
          label="公司名"
          width="300"
        ></el-table-column>
        <el-table-column
          prop="workPlace"
          label="工作地点"
          width="240"
        ></el-table-column>
        <el-table-column
          prop="salary"
          label="薪资"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="publishDate"
          label="发布时间"
          width="160"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        style="text-align: right; margin-top: 15px; background: #fff"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { tree_meta_qy, recruitJob_qy } from "@/api/home";
export default {
  data() {
    return {
      time: [
        {
          dateFm: null,
          dateTo: null,
        },
        {
          dateFm: moment().add(-24, "hours").format("YYYY-MM-DD HH:mm:ss"),
          dateTo: moment().format("YYYY-MM-DD HH:mm:ss"),
        },
        {
          dateFm: moment().add(-3, "days").format("YYYY-MM-DD HH:mm:ss"),
          dateTo: moment().format("YYYY-MM-DD HH:mm:ss"),
        },
        {
          dateFm: moment().add(-7, "days").format("YYYY-MM-DD HH:mm:ss"),
          dateTo: moment().format("YYYY-MM-DD HH:mm:ss"),
        },
        {
          dateFm: moment().add(-1, "months").format("YYYY-MM-DD HH:mm:ss"),
          dateTo: moment().format("YYYY-MM-DD HH:mm:ss"),
        },
        {
          dateFm: null,
          dateTo: moment().add(-1, "months").format("YYYY-MM-DD HH:mm:ss"),
        },
      ],
      input: "",
      active: "0",
      active2: "0",
      metaQyList: [],
      tableData: [],
      pageNo: 1,
      pageSize: 50,
      totalCount: 0,
      salaryFm: "",
      salaryTo: "",
    };
  },
  created() {
    this.getMeta();
    this.getList();
  },
  methods: {
    rowClick(val) {
      let routerJump;

      routerJump = this.$router.resolve({
        name: "recruitJobDetail",
        query: {
          id: this.$route.query.id,
          recruitJobId: val.recruitJobId,
        },
      });

      window.open(routerJump.href, "_blank");

      // this.$router.push({
      //   path: "/recruitJobDetail",
      //   query: {
      //     id: this.$route.query.id,
      //     recruitJobId: val.recruitJobId
      //   }
      // });
    },
    handleSizeChange() {},
    handleCurrentChange() {},
    change(val, obj) {
      this.pageNo = 1;
      this.getList();
      console.log(this.time);
    },
    changeType2(item) {
      this.active2 = item.id;
      if (this.active2 != "0") {
        if (item.nodeName == "10000以上") {
          this.salaryFm = "10000";
          this.salaryTo = "";
        } else {
          var arr = item.nodeName.split("~");
          this.salaryFm = arr[0];
          this.salaryTo = arr[1];
        }
      } else {
        this.salaryFm = "";
        this.salaryTo = "";
      }

      this.$forceUpdate();
      this.change();
    },
    changeType(type) {
      this.active = type;
      this.change();
      this.$forceUpdate();
    },
    getMeta() {
      tree_meta_qy({ op: "findListSalaryStandard" }).then((res) => {
        this.metaQyList = res;
      });
    },
    getList() {
      const data = { ...this.time[this.active] };
      if (!data.dateFm) {
        delete data.dateFm;
      }
      if (!data.dateTo) {
        delete data.dateTo;
      }
      // if (this.active2 != "0") {
      //   data.salaryStandardId = this.active2;
      // }
      data.salaryFm = this.salaryFm;
      data.salaryTo = this.salaryTo;
      recruitJob_qy({
        op: "findPageRecruitJob",
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        retrieveArg: this.input,
        ...data,
      }).then((res) => {
        this.totalCount = res.totalCount;
        this.tableData = [];
        for (let i = 0; i < res.result.length; i++) {
          const b = {};
          b.jobName = res.result[i].jobName;
          b.enterpriseName = res.result[i].enterpriseName;
          b.workPlace = res.result[i].workPlace;
          b.recruitJobId = res.result[i].recruitJobId;
          b.salary = res.result[i].salaryFm + "~" + res.result[i].salaryTo;
          if (res.result[i].salaryStandard) {
            b.salary = res.result[i].salaryStandard.nodeName;
          }
          b.publishDate = moment(res.result[i].publishDate).format("MM-DD");
          this.tableData.push(b);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  margin: 0 auto;
  padding-top: 50px;
  /deep/.has-gutter {
    .is-leaf {
      background: #f0f0f0;
    }
  }
  .condition {
    border: 1px solid #ddd;
    background: #fff;
    .type {
      text-align: center;
      color: #999;
      line-height: 40px;
    }
    .typeBut {
      margin: 5px 10px;
      display: inline-block;
      color: #999;
      font-size: 14px;
      cursor: pointer;
      line-height: 30px;
      padding: 0 15px;
    }
    .all {
      color: #f8a76b;
    }
    .typeBut:hover {
      background: #cdf4f1;
    }
    .typeBut.active {
      background: #1890ff;
      color: #fff;
    }
  }
}
</style>